export const avatars = [
    {
        lottieSrc: 'animations/Naransoya.json',
        questionsTheme: 'naransoya'
    },
    {
        lottieSrc: 'animations/gofi.json',
        questionsTheme: 'gofi'
    },
    {
        lottieSrc: 'animations/abeja.json',
        questionsTheme: 'taramiel'
    },
];
export const preloadResources = [
    {
        src: '/animations/todo_el_grupo.json',
        linkAs: "fetch",
    },
    {
        src: "/animations/abeja.json",
        linkAs: "fetch"
    },
    {
        src: "/animations/gofi.json",
        linkAs: "fetch"
    },
    {
        src: "/animations/Naransoya.json",
        linkAs: "fetch"
    },
    {
        src: "/animations/todo_el_grupo.json",
        linkAs: "fetch"
    },
    {
        src: "/images/logo_telde.png",
        linkAs: "image"
    },
    {
        src: "/images/heart.svg",
        linkAs: "image"
    },
    {
        src: "/images/clock.svg",
        linkAs: "image"
    },
    {
        src: "/images/points.svg",
        linkAs: "image"
    },
];
